module.exports = __webpack_public_path__ + "q.no2.f5c06d00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/q.no2.jpg
// module id = GY07
// module chunks = 0